const STORAGE_KEY = 'xgain_pending_verification_user';

export const persistVerificationUser = (user) => {
  if (!user) return;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(user));
};

export const loadVerificationUser = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearVerificationUser = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

export const isVerificationRequiredError = (error) =>
  error?.response?.status === 403
  && error?.response?.data?.code === 'VERIFICATION_REQUIRED';

export const getVerificationRedirectPath = (payload) =>
  `/verify/${payload?.nextStep || 'phone'}`;
